import "./invalidRoom.css";
const InvalidRoom = () => {
  return (
    <div className="container">
      <p className="text">Error:404</p>
      <p className="text">Page Not Found!</p>
      <p className="text">You Have Entered Invalid details...</p>
    </div>
  );
};
export default InvalidRoom;
